import { Text } from '@etg/wings';
import { useProductCardContext } from '../context/ProductCardContext';
import { airportRow, listWrapper, title } from './styles';
import AvailabilityStatus from './AvailabilityStatus';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const AirportList = props => {
  var _productData$extraPro;
  const productData = useProductCardContext();
  const availabilityText = (_productData$extraPro = productData.extraProps) === null || _productData$extraPro === void 0 || (_productData$extraPro = _productData$extraPro.availabilityTranslation) === null || _productData$extraPro === void 0 ? void 0 : _productData$extraPro.availabilityCard;
  const {
    availabilityList,
    testId,
    listTitle,
    isSelected,
    hideTitle
  } = props;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (availabilityList === null || availabilityList === void 0 ? void 0 : availabilityList.length) > 0 && /*#__PURE__*/_jsxs("div", {
      "data-testid": testId,
      children: [!hideTitle && listTitle && /*#__PURE__*/_jsx(Text, {
        className: title,
        children: listTitle
      }), /*#__PURE__*/_jsx("div", {
        className: listWrapper,
        children: availabilityList.map((airport, index) => {
          return /*#__PURE__*/_jsxs("div", {
            className: airportRow(airport.available),
            children: [/*#__PURE__*/_jsx(Text, {
              className: "airportName",
              children: airport.departureAirport
            }), /*#__PURE__*/_jsx(AvailabilityStatus, {
              isAirportAvailable: airport.available,
              isCardSelected: isSelected,
              text: availabilityText
            })]
          }, index);
        })
      })]
    })
  });
};
export default AirportList;